import React from 'react';
import classnames from 'classnames';
import styles from './highlightedText.module.css';

interface HighlightedTextProps {
  capitalize?: boolean;
  children: string | string[];
  dataTestId?: string;
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  capitalize,
  children,
  ...props
}) => (
  <span
    className={classnames(styles.highlightedText, {
      [styles.highlightedTextCapitalize]: capitalize,
    })}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </span>
);
